import {
  ControlledSelect,
  ControlledTextField
} from 'components/shared/ControlledFields';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import { Option } from 'components/shared/ControlledFields/ControlledSelect';

const importTypeOptions: Option[] = [
  {
    value: 'Aysist',
    label: 'Aysist'
  }
];

export const FormContent = () => {
  const { t } = useTranslation('common');
  const { control } = useFormContext();

  return (
    <>
      <ControlledSelect
        options={importTypeOptions}
        name="import_duty_line_year_type"
        label={t('importDutyLineYearSettings.importType')}
        control={control}
      />
      <ControlledTextField
        name="import_duty_line_year_filePath"
        label={t('importDutyLineYearSettings.s3FilePath')}
        control={control}
      />
    </>
  );
};
